import axios from "./axios-decorator";

const baseAxiosUrl = window.location.origin;

/**
* Create the user token.
*/
export const createUserToken = async (requestedScopes?: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/acs/createUserToken`;
    return await axios.getAnonymous(url);
}

/**
* Refresh the user token.
*/
export const refreshUserToken = async (userId: string, requestedScopes?: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/acs/refreshUserToken?userId=${userId}`;
    return await axios.getAnonymous(url);
}

/**
* Validates if the Acs is enabled or not.
*/
export const isAcsEnabled = async (): Promise<any> => {
    let url = `${baseAxiosUrl}/api/acs/isAcsEnabled`;
    return await axios.getAnonymous(url);
}

/**
* Validates if the Acs is enabled or not.
*/
export const acsMeetingError = async (userName: string | undefined, queueId: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/acs/acsMeetingError?userName=${userName}&queueId=${queueId}`;
    return await axios.putAnonymous(url);
}


